import React from "react";
import CRUDPage from "./CRUDPage";

const RenderImg = (key) => (it) => it[key] ? <img src={it[key].startsWith("http") ? it[key] : (process.env.REACT_APP_BACKEND_URL + it[key])} alt="" className="w-16 h-10 rounded object-cover" /> : <span className="text-slate-400 text-xs">—</span>;

export const NewsManage = () => (
  <CRUDPage
    title="Berita"
    endpoint="news"
    defaults={{ title: "", excerpt: "", content: "", category: "Sekolah", thumbnail_url: "", author: "Admin", status: "published", featured: false }}
    fields={[
      { name: "title", label: "Judul", full: true },
      { name: "slug", label: "Slug (opsional)" },
      { name: "category", label: "Kategori", type: "select", options: ["Sekolah", "Akademik", "Prestasi", "Olahraga", "Seni", "Literasi", "PPDB", "Pengumuman", "Event"] },
      { name: "status", label: "Status", type: "select", options: ["draft", "published"] },
      { name: "author", label: "Penulis" },
      { name: "excerpt", label: "Ringkasan", type: "textarea", rows: 2, full: true },
      { name: "content", label: "Isi Artikel (HTML)", type: "textarea", rows: 8, full: true },
      { name: "thumbnail_url", label: "Thumbnail", type: "file", full: true },
      { name: "featured", label: "Featured", type: "boolean" },
    ]}
    columns={[
      { key: "thumbnail_url", label: "Gambar", render: RenderImg("thumbnail_url") },
      { key: "title", label: "Judul" },
      { key: "category", label: "Kategori" },
      { key: "status", label: "Status" },
    ]}
  />
);

export const AnnouncementsManage = () => (
  <CRUDPage title="Pengumuman" endpoint="announcements"
    defaults={{ title: "", content: "", status: "active" }}
    fields={[
      { name: "title", label: "Judul", full: true },
      { name: "status", label: "Status", type: "select", options: ["active", "archived"] },
      { name: "content", label: "Isi", type: "textarea", rows: 5, full: true },
      { name: "attachment_url", label: "Lampiran (PDF)", type: "file", full: true },
    ]}
    columns={[
      { key: "title", label: "Judul" },
      { key: "status", label: "Status" },
      { key: "created_at", label: "Tanggal", render: (it) => <span>{new Date(it.created_at).toLocaleDateString("id-ID")}</span> },
    ]}
  />
);

export const TeachersManage = () => (
  <CRUDPage title="Guru & Tenaga Kependidikan" endpoint="teachers"
    defaults={{ name: "", title: "", position: "", subject: "", bio: "", photo_url: "" }}
    fields={[
      { name: "name", label: "Nama" }, { name: "title", label: "Gelar" },
      { name: "position", label: "Jabatan" }, { name: "subject", label: "Mata Pelajaran" },
      { name: "bio", label: "Biografi", type: "textarea", rows: 3, full: true },
      { name: "photo_url", label: "Foto", type: "file", full: true },
    ]}
    columns={[
      { key: "photo_url", label: "Foto", render: RenderImg("photo_url") },
      { key: "name", label: "Nama" }, { key: "position", label: "Jabatan" }, { key: "subject", label: "Mapel" },
    ]}
  />
);

export const AchievementsManage = () => (
  <CRUDPage title="Prestasi" endpoint="achievements"
    defaults={{ name: "", student_name: "", category: "Akademik", level: "Kabupaten", year: new Date().getFullYear(), description: "", photo_url: "" }}
    fields={[
      { name: "name", label: "Nama Prestasi", full: true },
      { name: "student_name", label: "Nama Murid / Tim", full: true },
      { name: "category", label: "Kategori", type: "select", options: ["Akademik", "Olahraga", "Seni", "Sains", "Literasi", "Teknologi", "Bahasa", "Organisasi"] },
      { name: "level", label: "Tingkat", type: "select", options: ["Kabupaten", "Provinsi", "Nasional", "Internasional"] },
      { name: "year", label: "Tahun", type: "number" },
      { name: "description", label: "Deskripsi", type: "textarea", full: true },
      { name: "photo_url", label: "Foto", type: "file", full: true },
    ]}
    columns={[
      { key: "name", label: "Nama" }, { key: "student_name", label: "Murid" },
      { key: "category", label: "Kategori" }, { key: "level", label: "Tingkat" }, { key: "year", label: "Tahun" },
    ]}
  />
);

export const ExtracurricularsManage = () => (
  <CRUDPage title="Ekstrakurikuler" endpoint="extracurriculars"
    defaults={{ name: "", description: "", category: "Olahraga", coach: "", schedule: "", location: "", photo_url: "" }}
    fields={[
      { name: "name", label: "Nama" },
      { name: "category", label: "Kategori", type: "select", options: ["Olahraga", "Seni", "Teknologi", "Bahasa", "Sains", "Sosial", "Kepemimpinan", "Lainnya"] },
      { name: "coach", label: "Pembina" }, { name: "schedule", label: "Jadwal" }, { name: "location", label: "Lokasi" },
      { name: "description", label: "Deskripsi", type: "textarea", rows: 4, full: true },
      { name: "photo_url", label: "Foto", type: "file", full: true },
    ]}
    columns={[
      { key: "photo_url", label: "Foto", render: RenderImg("photo_url") },
      { key: "name", label: "Nama" }, { key: "category", label: "Kategori" }, { key: "coach", label: "Pembina" },
    ]}
  />
);

export const GalleryManage = () => (
  <CRUDPage title="Galeri" endpoint="gallery"
    defaults={{ title: "", category: "Kegiatan Sekolah", album: "", description: "", image_url: "" }}
    fields={[
      { name: "title", label: "Judul" },
      { name: "category", label: "Kategori", type: "select", options: ["Kegiatan Sekolah", "Akademik", "Olahraga", "Seni", "Literasi", "Event", "Prestasi", "Fasilitas", "PPDB"] },
      { name: "album", label: "Album" },
      { name: "description", label: "Deskripsi", type: "textarea", full: true },
      { name: "image_url", label: "Gambar", type: "file", full: true },
    ]}
    columns={[
      { key: "image_url", label: "Gambar", render: RenderImg("image_url") },
      { key: "title", label: "Judul" }, { key: "category", label: "Kategori" },
    ]}
  />
);

export const FacilitiesManage = () => (
  <CRUDPage title="Fasilitas" endpoint="facilities"
    defaults={{ name: "", description: "", image_url: "" }}
    fields={[
      { name: "name", label: "Nama Fasilitas", full: true },
      { name: "description", label: "Deskripsi", type: "textarea", full: true },
      { name: "image_url", label: "Gambar", type: "file", full: true },
    ]}
    columns={[
      { key: "image_url", label: "Gambar", render: RenderImg("image_url") },
      { key: "name", label: "Nama" },
    ]}
  />
);

export const EventsManage = () => (
  <CRUDPage title="Kalender Sekolah" endpoint="events"
    defaults={{ title: "", start_date: "", end_date: "", category: "Akademik", description: "" }}
    fields={[
      { name: "title", label: "Judul", full: true },
      { name: "category", label: "Kategori", type: "select", options: ["Akademik", "Ujian", "Libur", "Kegiatan sekolah", "Kompetisi", "Olahraga", "Seni", "PPDB"] },
      { name: "start_date", label: "Tanggal Mulai", type: "date" },
      { name: "end_date", label: "Tanggal Selesai (opsional)", type: "date" },
      { name: "description", label: "Deskripsi", type: "textarea", full: true },
    ]}
    columns={[
      { key: "title", label: "Judul" }, { key: "category", label: "Kategori" },
      { key: "start_date", label: "Mulai" },
    ]}
  />
);

export const DocumentsManage = () => (
  <CRUDPage title="Dokumen" endpoint="documents"
    defaults={{ title: "", category: "Formulir", description: "", file_url: "", file_name: "" }}
    fields={[
      { name: "title", label: "Judul Dokumen", full: true },
      { name: "category", label: "Kategori", type: "select", options: ["Formulir", "Surat", "Kalender", "Panduan PPDB", "Peraturan", "Dokumen akademik", "Proposal", "Lainnya"] },
      { name: "file_name", label: "Nama File" },
      { name: "description", label: "Deskripsi", type: "textarea", full: true },
      { name: "file_url", label: "File", type: "file", full: true },
    ]}
    columns={[{ key: "title", label: "Judul" }, { key: "category", label: "Kategori" }]}
  />
);
